import React, { useState } from "react";
import { Row, Button, Col, Form, Input, Spin, InputNumber } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { COLORS, FullSpan } from "../../../constants";
import PHAddressForm from "../../features/ph-address/PHAddressForm";
import EstablishmentCategory from "../../features/establishment-category/establishmentCategory";
import {
  createEstablishment,
  updateEstablishment,
} from "../../http-request/establishment";

import { establishmentInitialValue as initialValues } from "./initialValues";

import styles from "./styles/ManageTREPage.module.css";
import { useForm } from "antd/lib/form/Form";
import AppContainer from "../../components/AppContainer/AppContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Notification from "../../../components/shared/Notification";

function ManageTREPageCreate() {
  const location = useLocation().state;
  const params = useParams();
  const navigate = useNavigate();
  const locationData = location
    ? {
        ...location,
        barangay: location?.barangayCode,
        municipality: location?.municipalityCode,
        province: location?.provinceCode,
        region: location?.regionCode,
        category: location?.category._id,
      }
    : null;

  const [forms] = useForm();
  const [isCreating, setisCreating] = useState(false);

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
  );

  return (
    <AppContainer title="TRE ACCOUNTS">
      <center>
        <div style={{ margin: "20px 0px", width: "80vw" }}>
          <Form
            form={forms}
            initialValues={locationData || initialValues}
            {...FullSpan}
            onFinish={async (value) => {
              setisCreating(true);

              if (locationData) {
                if (!params.id) {
                  Notification(
                    "Error",
                    "Invalid Selected Establishment!",
                    "error"
                  );
                  navigate(-1);
                  return;
                }
                await updateEstablishment(params.id, value).finally(() => {
                  setisCreating(false);
                  navigate(-1);
                });
              } else {
                await createEstablishment(value).finally(() => {
                  setisCreating(false);
                  forms.resetFields();
                });
              }
            }}
          >
            <div className={styles.info}>
              <EstablishmentCategory />
              <Row>
                <Col span={24}>
                  <Form.Item
                    labelAlign="left"
                    name="name"
                    label="TRE Name"
                    rules={[
                      {
                        required: true,
                        message: "Please input establishment!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <PHAddressForm forms={forms} locationData={locationData} />

              <Row>
                <Col span={24}>
                  <Form.Item
                    labelAlign="left"
                    name="noAvailableROoms"
                    label="No. of Available Rooms"
                    rules={[
                      {
                        required: true,
                        message: "Please input no. of available rooms!",
                      },
                    ]}
                  >
                    <InputNumber min={1} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    labelAlign="left"
                    name="holdingCapacity"
                    label="Holding Capacity"
                    rules={[
                      {
                        required: true,
                        message: "Please input holding capacity",
                      },
                    ]}
                  >
                    <InputNumber min={1} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    labelAlign="left"
                    name="attractionCode"
                    label="Attraction Code"
                    rules={[
                      {
                        required: true,
                        message: "Please input attraction code",
                      },
                    ]}
                  >
                    <Input style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Row justify="start" style={{ margin: "20px 0 20px 0" }}>
              <Col
                span={12}
                style={{ justifyContent: "flex-start", display: "flex" }}
              >
                <Button
                  htmlType="reset"
                  style={{ border: 0, backgroundColor: COLORS.orange }}
                >
                  DISCARD
                </Button>
              </Col>
              <Col
                span={12}
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                <Button disabled={isCreating} htmlType="submit" type="primary">
                  {isCreating ? (
                    <Spin indicator={antIcon} />
                  ) : locationData ? (
                    "UPDATE"
                  ) : (
                    "SAVE"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </center>
    </AppContainer>
  );
}

export default ManageTREPageCreate;
